import { useMemo } from 'react';
import {
  useLocation, useNavigate
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { PAGES_WITH_BACK_LINKS } from '../constants/AppUrlConstants';
import Header from './Header';
import Footer from './Footer';

const Page = ({ children }) => {
  const navigate = useNavigate();
  const { pathname, state } = useLocation();
  const suppressBackLink = Boolean(state?.suppressBack);
  const pageWithBackLinks = useMemo(
    () => PAGES_WITH_BACK_LINKS.some((page) => pathname === page || pathname.startsWith(`${page}/`)),
    [pathname]
  );

  return (
    <div className="hods-page">
      <Header />
      <div className="hods-page__body">
        <div className="container hods-width-container">
          {pageWithBackLinks && !suppressBackLink
            && (
              <nav aria-label="Back link" id="backLink">
                <a
                  href="#back"
                  className="govuk-back-link"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                  }}
                >
                  Back
                </a>
              </nav>
            )}
          <main id="main-content" tabIndex="-1" className="hods-page__main" aria-live="polite" data-testid="main-content">
            {children}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Page;

Page.propTypes = {
  children: PropTypes.node.isRequired
};
